<template>
	<div v-if="shouldShowEducationTable" class="mt-4">
		<h2 class="text-left">
			{{ $t('education.education') }}
		</h2>
		<div class="mb-4 mobile-overflow-table">
			<table class="table mb-0 table-striped">
				<thead class="thead-dark">
					<tr>
						<th v-if="match"></th>
						<th class="w-34">
							{{ $t('job-offer.educationType') }}
						</th>
						<th class="w-33">
							{{ $t('general.job-offer') }}
						</th>
						<th v-if="match" class="w-33">
							{{ $t('general.applicant-profile') }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="edu in getSortedEducation"
						:key="edu.id"
						v-if="edu.job.length > 0 || edu.applicant.length > 0"
					>
						<th
							v-if="jobOffer && applicantProfile"
							:class="getMatchClasses(edu.id)"
							width="50"
							class="align-top"
						>
							<Icon
								v-if="getMatchClasses(edu.id) !== 'bonus'"
								class="w-5"
								:icon="[
									'far',
									getMatchClasses(edu.id) === 'matched'
										? 'check'
										: 'times'
								]"
							/>
						</th>

						<th class="align-top">
							{{ edu[$getLocaleDbColumn('name')] }}
						</th>

						<td v-if="jobOffer" class="align-top">
							<ul class="pl-0 mb-0">
								<li
									v-for="(el, index) in edu.job"
									:key="index"
									class="mb-2"
								>
									{{
										el.pivot && el.pivot.name
											? el.pivot.name
											: el.name
									}}
								</li>
							</ul>
						</td>
						<td v-if="applicantProfile" class="align-top">
							<ul class="pl-0 mb-0">
								<li
									v-for="(el, index) in edu.applicant"
									:key="index"
									class="mb-2"
								>
									{{
										el.pivot && el.pivot.name
											? el.pivot.name
											: el.name
									}}
									<span
										v-if="
											(el.pivot && el.pivot.end_year) ||
												el.end_year
										"
									>
										<br />
										({{ $t('education.end-year') }}
										{{
											el.pivot && el.pivot.end_year
												? el.pivot.end_year
												: el.end_year
										}})
									</span>
								</li>
							</ul>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import Icon from '~/components/ui/common/Icon'

export default {
	components: {
		Icon
	},
	props: ['jobOffer', 'match', 'applicantProfile', 'hideEmptyJobOfferTables'],
	data() {
		return {
			jobEdu: null,
			applicantEdu: null
		}
	},
	computed: {
		shouldShowEducationTable() {
			return !this.hideEmptyJobOfferTables || this.hasEducationRows
		},
		hasEducationRows() {
			return this.getSortedEducation.some(edu => {
				return (
					(edu.job && edu.job.length > 0) ||
					(edu.applicant && edu.applicant.length > 0)
				)
			})
		},
		getSortedEducation() {
			if (!this.jobOffer && !this.applicantProfile) return []
			if (!this.$filterCriteria) return []
			const types = this.$filterCriteria.educationTypes
			const jobEducationTypes = this.jobOffer?.educationTypes || []
			const applicantEducationTypes =
				this.applicantProfile?.educationTypes || []

			if (!this.jobOffer && types) {
				const applicantEdu = types.map(type => {
					const applicant = applicantEducationTypes.filter(
						e => e.id === type.id
					)

					return {
						...type,
						job: [],
						applicant,
						inUse: applicant.length !== 0
					}
				})

				return applicantEdu.filter(e => e.inUse)
			}

			if (!this.applicantProfile && types) {
				const jobEdu = types.map(type => {
					const job = jobEducationTypes.filter(
						e => e.id === type.id
					)

					return {
						...type,
						job,
						applicant: [],
						inUse: job.length !== 0
					}
				})

				return jobEdu.filter(e => e.inUse)
			}

			const sorted = types.map(type => {
				const job = jobEducationTypes.filter(
					e => e.id === type.id
				)
				const applicant = applicantEducationTypes.filter(
					e => e.id === type.id
				)

				return {
					...type,
					job,
					applicant,
					inUse: job.length !== 0 || applicant.length !== 0
					// maxLength: Math.max(job.length, applicant.length),
				}
			})

			const filtered = sorted.filter(e => e.inUse)

			return filtered.sort((a, b) => b.job.length - a.job.length)
		}
	},
	methods: {
		getMatchClasses(id) {
			const eduType = this.getSortedEducation.find(e => e.id === id)
			if (!eduType) return 'not-matched'

			if (eduType.job.length === 0) {
				return 'bonus'
			} else if (eduType.applicant.length === 0) {
				return 'not-matched'
			} else {
				return 'matched'
			}
		}
	}
}
</script>
